// src/constants.js

export const DATE_FORMAT_AM_PM = "yyyy-MM-dd hh:mm:ss a"; // 12-hour format with AM/PM
export const DATE_FORMAT_ISO = "yyyy-MM-dd HH:mm:ss"; // 24-hour format
export const DATE_FORMAT_FRIENDLY = "MM/dd/yyyy hh:mm a"; // Example for user-friendly format
